export default __webpack_public_path__ + "e5117e8e0cea57c9a92f0603011083a3.png";